import styled from 'styled-components'
import { InlineInput } from '@velasca/ui/inline-input'

export const Wrapper = styled.div`
  text-align: center;
  max-width: 50rem;
  margin: 0 auto;

  @media screen and (min-width: 992px) {
    max-width: 100%;
  }
`

export const StyledInlineInput = styled(InlineInput)`
  margin: 2.4rem auto 1.2rem;
  max-width: 46rem;
`

export const PolicyTextContainer = styled.div`
  margin: 1.5rem 1.3rem;

  @media screen and (min-width: 768px) {
    margin: 1.5rem 3rem;
  }
`

export const TextWrapper = styled.div`
  max-width: 36rem;
  margin: 0 auto;
  margin-top: 2.4rem;
`
